import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik, useField } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import moment from "moment";

//
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

//Services
import LocationApi from "Services/Location";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RestrictedLocationModalCreate = (props) => {
  const { open, handleClose, locationId } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [values, setValues] = useState(null);
  const [locationData, setLocationData] = useState([]);

  //pagination

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState("unlimited");

  //Time pickers

  const [startingTime, setStartingTime] = useState(null);
  const [endingTime, setEndingTime] = useState(null);

  const [startingTimeData, setStartingTimeData] = useState([]);
  const [endingTimeData, setEndingTimeData] = useState([]);

  //
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [newLocationName, setNewLocationName] = useState("");
  const [newLocationId, setNewLocationId] = useState(null);

  const [restrictLocationDetails, setRestrictLocationDetails] = useState([]);

  //

  const getAllLocations = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setValues(res?.data?.data?.data);
      } else {
        setValues(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    LocationApi.getServiceArea().then(onSuccess, onFailure);
  }, []);

  //

  const getRestrictLocationDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setRestrictLocationDetails(res?.data.data);
      } else {
        setRestrictLocationDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    LocationApi.restrictLocationDetailsGet(locationId).then(
      onSuccess,
      onFailure
    );
  }, [locationId]);

  useEffect(() => {
    open && getRestrictLocationDetails();
    getAllLocations();
  }, [open]);

  useEffect(() => {
    // formik.setFieldValue(
    //   "locationName",
    //   restrictLocationDetails?.locationId?.locationName
    // );

    //setNewLocationName(restrictLocationDetails?.locationId?.locationName);

    setSelectedLocation({
      locationId: restrictLocationDetails?.locationId,
      locationName: restrictLocationDetails?.locationId?.locationName,
    });

    formik.setFieldValue(
      "restrictType",
      restrictLocationDetails?.restrictionType
    );

    const startingTimeFormatted = dayjs()
      .set("hour", restrictLocationDetails?.startingTime?.hour)
      .set("minute", restrictLocationDetails?.startingTime?.minutes)
      .set("second", restrictLocationDetails?.startingTime?.seconds)
      .format("YYYY-MM-DDTHH:mm:ss");

    const endingTimeFormatted = dayjs()
      .set("hour", restrictLocationDetails?.endingTime?.hour)
      .set("minute", restrictLocationDetails?.endingTime?.minutes)
      .set("second", restrictLocationDetails?.endingTime?.seconds)
      .format("YYYY-MM-DDTHH:mm:ss");

    setStartingTime(startingTimeFormatted);
    setEndingTime(endingTimeFormatted);

    setStartingTimeData({
      hour: restrictLocationDetails?.startingTime?.hour,
      minutes: restrictLocationDetails?.startingTime?.minutes,
      seconds: restrictLocationDetails?.startingTime?.seconds,
      timeFormat: restrictLocationDetails?.startingTime?.timeFormat,
    });
    setEndingTimeData({
      hour: restrictLocationDetails?.endingTime?.hour,
      minutes: restrictLocationDetails?.endingTime?.minutes,
      seconds: restrictLocationDetails?.endingTime?.seconds,
      timeFormat: restrictLocationDetails?.endingTime?.timeFormat,
    });

    formik.setFieldValue("startingTime", startingTimeFormatted);
    formik.setFieldValue("endingTime", endingTimeFormatted);
  }, [restrictLocationDetails]);

  //Add restrict location

  const UpdateRestrictLocation = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    let data = {
      locationId: selectedLocation?._id,
      restrictionType: formValues?.restrictType,
      startingTime: {
        hour: startingTimeData?.hour,
        minutes: startingTimeData?.minutes,
        seconds: startingTimeData?.seconds,
        timeFormat: startingTimeData?.timeFormat,
      },
      endingTime: {
        hour: endingTimeData?.hour,
        minutes: endingTimeData?.minutes,
        seconds: endingTimeData?.seconds,
        timeFormat: endingTimeData?.timeFormat,
      },
    };

    const onSuccess = (res) => {
      // formik.setFieldValue("locationName", "");
      // formik.setFieldValue("restrictType", "PICKUP");
      setStartingTime(null);
      setEndingTime(null);
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: res?.data?.message || "Updated successfully",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );
      handleClose();
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while updating",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    LocationApi.restrictLocationUpdate(locationId, data).then(
      onSuccess,
      onFailure
    );
  };

  // Formik

  const formik = useFormik({
    initialValues: {
      locationName: null, // Assuming you want it to be nullable
      restrictType: "PICKUP",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      locationName: yup
        .string()
        .nullable()
        .trim()
        .min(3, "Name must be at least 3 letters")
        .max(50, "Max 50 characters are allowed"),
    }),
    onSubmit: UpdateRestrictLocation,
  });

  // Formik - Set fetched values for master
  useEffect(() => {
    if (!_.isEmpty(values)) {
      //console.log("the values ", values);
      setLocationData(values);
    }
  }, [values]);

  const handleAutocompleteChange = (event, newValue) => {
    //console.log("newValue ", newValue);

    setSelectedLocation(newValue);
    //setNewLocationName(newValue?.locationName);
    setNewLocationId(newValue?.locationId);
  };

  //handle startingTime change

  const handleStartingTimeChange = (newValue) => {
    setStartingTime(newValue);

    if (newValue) {
      // Convert newValue to a Date object if it's not already
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);

      // Extracting hour, minutes, and seconds
      const hour = selectedDate.getHours();
      const minutes = selectedDate.getMinutes();
      const seconds = selectedDate.getSeconds();

      // Determine time format (12-hour or 24-hour)
      const timeFormat = hour >= 12 ? 12 : 24;

      // Update state or perform any other action with the extracted values
      // console.log({
      //   hour,
      //   minutes,
      //   seconds,
      //   timeFormat,
      // });

      setStartingTimeData({
        hour,
        minutes,
        seconds,
        timeFormat,
      });
    }
  };

  const handleEndingTimeChange = (newValue) => {
    formik.setFieldError("endingTime", "");
    setEndingTime(newValue);
    if (newValue < startingTime) {
      formik.setFieldError(
        "endingTime",
        "Ending time cannot be less than starting time"
      );
    } else {
      if (newValue) {
        // Convert newValue to a Date object if it's not already
        const selectedDate =
          newValue instanceof Date ? newValue : new Date(newValue);

        // Extracting hour, minutes, and seconds
        const hour = selectedDate.getHours();
        const minutes = selectedDate.getMinutes();
        const seconds = selectedDate.getSeconds();

        // Determine time format (12-hour or 24-hour)
        const timeFormat = hour >= 12 ? 12 : 24;

        // Update state or perform any other action with the extracted values
        // console.log({
        //   hour,
        //   minutes,
        //   seconds,
        //   timeFormat,
        // });
        setEndingTimeData({ hour, minutes, seconds, timeFormat });
      }
    }
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Update Restriction Location
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.avatarContainer}></Grid>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid item xs={12}>
                  <div className={classes.header}>
                    <Typography variant="body1">
                      Update Restrict Location
                    </Typography>
                  </div>
                </Grid>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      style={{ margin: "20px 0px" }}
                    >
                      <Autocomplete
                        disablePortal
                        name="locationName"
                        id="locationName"
                        label="locationName"
                        value={selectedLocation}
                        onChange={handleAutocompleteChange}
                        getOptionLabel={(location) => location.locationName}
                        options={locationData}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select a Location"
                            error={
                              formik?.errors?.locationName &&
                              formik?.touched?.locationName
                            }
                            helperText={
                              formik?.errors?.locationName &&
                              formik?.touched?.locationName
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                      <TextField
                        name="restrictType"
                        id="restrictType"
                        select
                        label="Restrict Type"
                        value={formik?.values?.restrictType}
                        defaultValue={formik?.values?.restrictType}
                        onChange={formik?.handleChange}
                        error={
                          formik?.errors?.restrictType &&
                          formik?.touched?.restrictType
                        }
                        helperText={
                          formik?.errors?.restrictType &&
                          formik?.touched?.restrictType &&
                          formik?.errors?.restrictType
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        {["PICKUP", "DROP", "ALL"].map((option) => (
                          <MenuItem key={option} value={option}>
                            {option === "PICKUP"
                              ? "Pickup"
                              : option === "DROP"
                              ? "Drop"
                              : "All"}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid
                      container
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.containerWrapper}
                    >
                      <Grid item xs={12} md={6} lg={6} xl={6}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          size="small"
                        >
                          <TimePicker
                            name="startingTime"
                            id="startingTime"
                            label="Starting Time"
                            value={startingTime}
                            defaultValue={formik.values.startingTime}
                            size="small"
                            className={classes.timePickerStyle}
                            onChange={(newValue) => {
                              handleStartingTimeChange(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={
                                  formik?.errors?.startingTime &&
                                  formik?.touched?.startingTime
                                }
                                helperText={
                                  formik?.errors?.startingTime &&
                                  formik?.touched?.startingTime &&
                                  formik?.errors?.startingTime
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6} xl={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            name="endingTime"
                            id="endingTime"
                            label="Ending Time"
                            value={endingTime}
                            defaultValue={"2023-12-07T10:48:00"}
                            size="small"
                            className={classes.timePickerStyle}
                            onChange={(newValue) => {
                              handleEndingTimeChange(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={
                                  formik?.errors?.endingTime &&
                                  formik?.touched?.endingTime
                                }
                                helperText={
                                  formik?.errors?.endingTime &&
                                  formik?.touched?.endingTime &&
                                  formik?.errors?.endingTime
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                        {/* <Typography>{formik?.errors?.endingTime}</Typography> */}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container xs={12} md={12} lg={12} xl={12}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{
                      float: "right",
                      margin: "30px 10px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    <Button variant="contained" onClick={formik?.handleSubmit}>
                      Update Restriction
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </section>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RestrictedLocationModalCreate;
